type DataPoint = {
  date: string;
};

export function calculateDataCountByDayOfWeek(
  data: DataPoint[] | string[]
): Record<number, number> {
  return data.reduce(
    (acc, item) => {
      const date = typeof item === 'string' ? item : item.date;
      const dayOfWeek = new Date(date).getUTCDay();
      acc[dayOfWeek] = (acc[dayOfWeek] ?? 0) + 1;
      return acc;
    },
    {} as Record<number, number>
  );
}

export function calculateLatestDate(data: DataPoint[] | string[]): number {
  return Math.max(
    ...data.map(item => {
      const date = typeof item === 'string' ? item : item.date;
      return new Date(date).getTime();
    })
  );
}

export function calculateFirstDate(data: DataPoint[] | string[]): number {
  return Math.min(
    ...data.map(item => {
      const date = typeof item === 'string' ? item : item.date;
      return new Date(date).getTime();
    })
  );
}
